'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import { type } from 'jquery';
import routes from './map.routes';

export class MapComponent {
  /*@ngInject*/
  constructor($state, $scope, navService, fetch, $http, mapService, userService, lookup, $stateParams) {
    this.$scope = $scope;
    this.$http = $http;
    this.$state = $state;
    this.navService = navService;
    this.mapService = mapService;
    this.userService = userService;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;

    // $scope.sphereofinfluenceLayerToggle = true;
    $scope.selectedRecordDetails = [];
    $scope.selectedRecords = [];
    $scope.filter = {};
    $scope.parcels = {};
    $scope.basemap = {};
    $scope.saved = false;
    $scope.saving = false;
    $scope.showParcelDetailsPanel = false; //Flag for showing/hiding parcel details panel in map sidebar
    $scope.tabPanelTypes = [{
      tab: 'filters',
      name: 'Filters',
      active: false,
      icon: 'fa-filter'
    }, {
      tab: 'basemap',
      name: 'Basemap',
      active: false,
      icon: 'fa-grid-2'
    }, {
      tab: 'legend',
      name: 'Legend',
      active: false,
      icon: 'fa-list'
    }, {
      tab: 'layers',
      name: 'Layers',
      active: false,
      icon: 'fa-layer-group'
    }];


    $scope.getStationbyID = function (stationId) {
      console.log($scope.filter);
      if(stationId){
        $scope.currentSelectedStationId = stationId;
      } else if($scope.filter.station_name){
        $scope.currentSelectedStationId = _.filter($scope.stationAreas,{station_name: $scope.filter.station_name})[0].sta_recid;
       
      }

    $scope.updateMap();
    lookup.setCurrentStation($scope.currentSelectedStationId);
      
      // lookup.setCurrentStation($scope.filter.station_name)
      $scope.loading = true;
      //Get zoning codes for specific station area
      setTimeout(function () {
        fetch.getItem(`api/data/density/averages/${$scope.currentJurisdiction}`, $scope.currentSelectedStationId)
          .then(response => {
            $scope.currentStation = response.data[0];
            $scope.loading = false;
          })
          .catch(err => {
            console.log(err);
            if(err.status === 403){
              $state.go('login');
            }
          })
      }, 2000)
    }

    $scope.getStationAreaList = function (jurisdiction) {
      // lookup.setCurrentStation(null);
      console.log(jurisdiction);
      if (jurisdiction) {
        $scope.currentJurisdiction = jurisdiction;
        lookup.setJurisdiction(jurisdiction);
      }

    //  Update zoning codes 
    $scope.getZoningCodes($scope.currentJurisdiction);

      fetch.getAllItems(`api/data/stationareas/${$scope.currentJurisdiction}`)
        .then(response => {
          $scope.stationAreas = response.data;
          if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation();
            $scope.filter.station_name = _.filter($scope.stationAreas,{sta_recid: $scope.currentSelectedStationId})[0].station_name;
            } else {
            $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
            $scope.filter.station_name = $scope.stationAreas[0].station_name;
          }

          lookup.setCurrentStation($scope.currentSelectedStationId);
          if (!$scope.map) {
            $scope.loadMap();
          }
          $scope.zoomToStation($scope.filter.station_name);
          $scope.getStationbyID($scope.currentSelectedStationId);

        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }

    $scope.downloadShapefile = function () {
      //  Download URL
      var downloadUrl = 'https://mtcdrive.box.com/s/131xc8gotpkdyfa8nvrtq0oq3qgubkr6';
  
      // Trigger the download
      window.location.href = downloadUrl; 
    }

    $scope.escapeCSVValue = function (value) {
      if (value == null) return ''; // handles null and undefined
      value = value.toString();
    
      // Escape quotes by doubling them, and wrap in quotes if there are special characters
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        value = '"' + value.replace(/"/g, '""') + '"';
      }
    
      return value;
    };

    $scope.downloadParcelData = function () {
      const headers = ['Jurisdiction ID', 'Jurisdiction', 'County ID', 'County Name', 'Station ID', 'APN', 'Acres Within Station Area', 'Total Parcels Area', 'Zone Code', 'Zone Description', 'TOC Min DUA', 'TOC Max DUA', 'TOC Min FAR', 'TOC Max FAR', 'Allows Commercial Office', 'Allows Residential'];
      const keys = ['jurisdiction_id', 'jurisdiction', 'county_id', 'county_name', 'sta_recid', 'apn', 'acres_within_station_area', 'total_parcels_area', 'zn_code', 'zn_description', 'toc_min_dua', 'toc_max_dua', 'toc_min_far', 'toc_max_far', 'allows_comm_office', 'allows_residential'];
    

      fetch.getAllItems(`api/data/parcelsData/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`)
        .then(response => {
          const data = response.data
          console.log(data)
    
          let csv = '';
          csv += headers.join(',') + '\n';
    
          data.forEach(row => {
            const rowValues = keys.map(key => $scope.escapeCSVValue(row[key]));
            csv += rowValues.join(',') + '\n';
          });
    
          const filename = prompt("Enter a filename for the CSV file:", `parcels_data_${$scope.currentJurisdiction}.csv`);
          if (filename === null) return;
    
          const link = document.createElement('a');
          link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => {
          console.error('Error exporting CSV:', error);
          alert('There was a problem exporting the data. Please try again.');
        });
    };
    
    //Load Mapbox map with config and map layers
    $scope.loadMap = function () {
      /**
      * Initializes the Mapbox map with the following configurations:
      * - Container: "map" (the id of the HTML element where the map will be rendered)
      * - Style: "mapbox://styles/mapbox/light-v10" (the Mapbox style to use)
      * - Zoom: 9 (initial zoom level)
      * - Center: [-122.275051, 37.796966] (initial center coordinates)
      * 
      * The function also adds the following controls to the map:
      * - Geocoder: Allows users to search for locations using a text input.
      * - Navigation: Provides zoom and rotation controls.
      * 
      * It then defines various map layers, including:
      * - Parcels: Displays parcel data from the "toc_parcels_v24d" vector tile source.
      * - Station Area Layer: Displays station area data from the "stationAreaLayerSource" geojson source.
      * - Jurisdiction Boundary: Displays jurisdiction boundaries from the "jurisdictionBoundarySource" geojson source.
      * - Parcels Highlighted: Highlights selected parcels.
      * - Parcel Selected: Displays the outline of the currently selected parcel.
      * 
      * The function also adds a MapboxDraw control, which allows users to draw polygons on the map.
      * 
      * Finally, it sets up event listeners for various map interactions, such as:
      * - Click: When a user clicks on a parcel, it displays information about the parcel in the sidebar.
      * - Mouseenter: When the mouse hovers over a parcel, it changes the cursor to a pointer.
      * - Mouseleave: When the mouse leaves a parcel, it resets the cursor.
      * - Mousedown: When the user holds down the shift key and clicks on the map, it enables box selection mode.
      * - Mousemove: When the user drags the mouse in box selection mode, it draws a box on the map.
      * - Mouseup: When the user releases the mouse in box selection mode, it selects all parcels within the box.
      * - Keydown: When the user presses the ESC key in box selection mode, it cancels the selection.
      * - Draw.create: When the user draws a polygon on the map, it selects all parcels that intersect with the polygon.
      */
      var map;
      
      var selectedRecords = [];
      var selectedRecordDetails = [];
      var loadMapLayers = function (map) {
        //    Add Parcels Source
        map.target.addSource("parcelsSource", {
          type: "vector",
          url: "mapbox://mtc-basis.toc_parcels_v24d", //Parcel Atlas (updated September 20 2021) 
        });

        //    Add Station Areas Source
        map.target.addSource("stationAreaLayerSource", {
          type: "geojson",
          data: stationAreasGeojson,
        });

        //Add jurisdiction boundary source
        map.target.addSource("jurisdictionBoundarySource", {
          type: "geojson",
          data: placesGeoJSON,
        });

        // Only add layer if it doesnt exist already 
        if (!map.target.getLayer("parcels")) {
        map.target.addLayer({
          id: "parcels",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "toc_parcels_v24d",
          'paint': {
            "fill-outline-color": "black",
            'fill-color': "white",
            'fill-opacity': 0.5
          },
  
        });
      }
  
      if (!map.target.getLayer("stationAreaLayer")) {
        map.target.addLayer({
          id: "stationAreaLayer",
          type: "fill",
          source: "stationAreaLayerSource",
          'paint': {
            "fill-outline-color": "white",
            'fill-color': {
              'property': 'service_tier',
              'type': 'categorical',
              'stops': [
                [1, 'yellow'],
                [2, 'green'],
                [3, 'red'],
                [4, 'purple']
              ],
              'default': 'white',
            },
            'fill-opacity': 0.5
          },
          'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
          }
  
        }, 'parcels');
      }
  
        //Jurisdiction Layer

        if (!map.target.getLayer("jurisdiction-boundary")) {
          map.target.addLayer({
            id: "jurisdiction-boundary",
            type: "line",
            source: "jurisdictionBoundarySource",
            paint: {
              "line-color": "black",
              "line-width": 2,
            },
            'layout': {
              'visibility': "visible", // Ensure the layer is visible by default
            },
            filter: ["in", "NAME", ""],
          });
        }

        //Selected Parcels
        if (!map.target.getLayer("parcels-highlighted")) {
          map.target.addLayer({
            id: "parcels-highlighted",
            type: "fill",
            source: "parcelsSource",
            "source-layer": "toc_parcels_v24d",
            paint: {
              "fill-outline-color": "darkgray",
              "fill-color": "#00fffa",
              "fill-opacity": 0.75,
            },
            filter: ["in", "parcel_id", ""],
          }); // Place polygon under these labels.
        }

       

        fetch.getAllItems(`api/data/excludedparcels/${$scope.currentJurisdiction}`)
        .then(response => {
          
            var array1 = ['in', 'parcel_id'];
            var array2 = response.data;
  
            var array3 = array1.concat(array2);
             //Excluded Parcels
          if (!map.target.getLayer("parcels-excluded")) {
            map.target.addLayer({
              id: "parcels-excluded",
              type: "fill",
              source: "parcelsSource",
              "source-layer": "toc_parcels_v24d",
              paint: {
                "fill-outline-color": "white",
                "fill-color": "#000444",
                "fill-opacity": 0.75,
              },
              filter: array3,
            },'parcels'); // Place polygon under these labels.
          }
         
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })




        //Currently Selected Parcel
        if (!map.target.getLayer("parcel-selected")) {
          map.target.addLayer({
            id: "parcel-selected",
            type: "line",
            source: "parcelsSource",
            "source-layer": "toc_parcels_v24d",
            'paint': {
              'line-color': '#888',
              'line-width': 6
            },
            filter: ["in", "parcel_id", ""],
          }); // Place polygon under these labels.
        }

        // ADD MAP LAYERS 
        $scope.mapLayers.forEach(element => {
          if (element.name === 'countyLayer') {
            map.target.addSource(`${element.name}Source`, {
              type: 'geojson',
              // Use a URL for the value for the `data` property.
              data: element.url
            });

            map.target.addLayer(
              {
                id: element.name,
                type: "line",
                source: `${element.name}Source`,
                paint: element.paint,
                'layout': {
                  // Make the layer visible by default.
                  'visibility': 'none'
                }
              }
            );
          }

        }, "parcels");

      }
      // $scope.filter.jurisdiction = $scope.currentJurisdiction;

      var updateInfoBox = this.updateInfoBox;
      // TO MAKE THE MAP APPEAR YOU MUST
      // ADD YOUR ACCESS TOKEN FROM
      // https://account.mapbox.com
      // define map
      mapboxgl.accessToken =
        "pk.eyJ1IjoibXRjLWJhc2lzIiwiYSI6ImNranVpYWNqeTFtMHEyeXRjdjFnN2lldTUifQ.09JACeDB27_PEaebVWA9rA";
      map = new mapboxgl.Map({
        container: "map", // container id
        style: "mapbox://styles/mapbox/light-v10", // stylesheet location
        zoom: 9,
        center: [-122.275051, 37.796966], //Set center based on geojson feature
      });

      /**
       * Add mapbox geocoder
       */
      map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,

          // limit results to US
          countries: "us",

          // further limit results to the geographic bounds representing the region of
          // California
          // bbox: [139.965, -38.03, 155.258, -27.839],

          // apply a client side filter to further limit results to those strictly within
          // the California region
          filter: function (item) {
            // returns true if item contains California region
            return item.context
              .map(function (i) {
                // id is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
                // this example attempts to find the `region` named `California`
                return (
                  i.id.split(".").shift() === "region" && i.text === "California"
                );
              })
              .reduce(function (acc, cur) {
                return acc || cur;
              });
          },
          mapboxgl: mapboxgl,
        })
      );

      // Add zoom and rotation controls to the map.
      map.addControl(new mapboxgl.NavigationControl());

      // Disable default box zooming.
      map.boxZoom.disable();

      var canvas = map.getCanvasContainer();
      // Variable to hold the starting xy coordinates
      // when `mousedown` occured.
      var start;
      // Variable to hold the current xy coordinates
      // when `mousemove` or `mouseup` occurs.
      var current;
      // Variable for the draw box element.
      var box;
      var draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: false,
          trash: false
        }
      });
      map.addControl(draw);
      //Zoom map to jurisdiction currently logged in
      // var zoomToFeature = _.filter(placesGeoJSON.features, function (item) {
      //   return item.properties.NAME === 'Alameda';
      // });

      // var bbox = turf.extent(zoomToFeature[0].geometry);
      // map.fitBounds(bbox, {
      //   padding: -150,
      // });

      // When a click event occurs on a feature in the states layer, open a popup at the
      // location of the click, with description HTML from its properties.
      map.on("click", "parcels", function (e) {
        // $('.mapboxgl-popup').remove();
        var coordinates = e.lngLat;
        selectedRecords = $scope.selectedRecords;
        selectedRecordDetails = $scope.selectedRecordDetails;
      
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        // set bbox as 5px reactangle area around clicked point
        var bbox = [
          [e.point.x - 5, e.point.y - 5],
          [e.point.x + 5, e.point.y + 5],
        ];
        var features = map.queryRenderedFeatures(bbox, {
          layers: ["parcels"],
        });
    
        //Query API to get parcel details base don parcel_id

        var feature = features[0];
        // map.setFilter('parcel-selected', ["==", "parcel_id", features[0].properties.parcel_id])

        var checkParcelId = feature.properties.parcel_id;
        var checkIndex = selectedRecords.indexOf(checkParcelId);
        var checkIndexDetails = selectedRecordDetails.indexOf(checkParcelId);

        if (checkIndex > -1) {
          // Remove record from selected map layer 
          selectedRecords.splice(checkIndex, 1);
          selectedRecordDetails.splice(checkIndexDetails, 1);
        } else {
          selectedRecords.push(feature.properties.parcel_id);
          console.log(selectedRecords)
          feature.properties.selected = true;
          var parcelDetails = {};
          fetch.getItem(`api/data/parcels`, features[0].properties.parcel_id)
            .then(response => {
              parcelDetails = response.data[0];
              parcelDetails.selected = true;
              selectedRecordDetails.push(parcelDetails);
              console.log(response);
            })
            .catch(error => {
              console.log(error);
            });

        }

        $scope.selectedRecords = selectedRecords;
        var array1 = ["in", "parcel_id"];
        var array2 = $scope.selectedRecords;

        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        map.setFilter("parcels-highlighted", array3);
        map.selectedFilter = array3;

        $scope.updateInfoBox(e.features[0].properties);
        // $scope.getStationbyID(e.features[0].properties.jurisdiction, e.features[0].properties.station_name)
        $scope.$apply();
        // $('#sidebar').addClass('show');
      });
      // Change the cursor to a pointer when the mouse is over the places layer.
      map.on('mouseenter', 'parcels', () => {
        map.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      map.on('mouseleave', 'parcels', () => {
        map.getCanvas().style.cursor = '';
      });
      // Set `true` to dispatch the event before other functions
      // call it. This is necessary for disabling the default map
      // dragging behaviour.
      canvas.addEventListener('mousedown', mouseDown, true);


      // Return the xy coordinates of the mouse position
      function mousePos(e) {
        var rect = canvas.getBoundingClientRect();
        return new mapboxgl.Point(
          e.clientX - rect.left - canvas.clientLeft,
          e.clientY - rect.top - canvas.clientTop
        );
      }

      function mouseDown(e) {
        // Continue the rest of the function if the shiftkey is pressed.
        if (!(e.shiftKey && e.button === 0)) return;

        // Disable default drag zooming when the shift key is held down.
        map.dragPan.disable();

        // Call functions for the following events
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('keydown', onKeyDown);

        // Capture the first xy coordinates
        start = mousePos(e);
      }

      function onMouseMove(e) {
        // Capture the ongoing xy coordinates
        current = mousePos(e);

        // Append the box element if it doesnt exist
        if (!box) {
          box = document.createElement('div');
          box.classList.add('boxdraw');
          canvas.appendChild(box);
        }

        var minX = Math.min(start.x, current.x),
          maxX = Math.max(start.x, current.x),
          minY = Math.min(start.y, current.y),
          maxY = Math.max(start.y, current.y);

        // Adjust width and xy position of the box element ongoing
        var pos = 'translate(' + minX + 'px,' + minY + 'px)';
        box.style.transform = pos;
        box.style.WebkitTransform = pos;
        box.style.width = maxX - minX + 'px';
        box.style.height = maxY - minY + 'px';
      }

      function onMouseUp(e) {
        // Capture xy coordinates
        finish([start, mousePos(e)]);
      }

      function onKeyDown(e) {
        // If the ESC key is pressed
        if (e.keyCode === 27) finish();
      }

      function finish(bbox) {
        // Remove these events now that finish has been called.
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('mouseup', onMouseUp);
        selectedRecordDetails = $scope.selectedRecordDetails;

        if (box) {
          box.parentNode.removeChild(box);
          box = null;
        }

        // If bbox exists. use this value as the argument for `queryRenderedFeatures`
        if (bbox) {
          var features = map.queryRenderedFeatures(bbox, {
            layers: ['parcels']
          });

          if (features.length >= 1000) {
            return window.alert('Select a smaller number of features');
          }

          selectedRecords = $scope.selectedRecords;

          // Run through the selected features and set a filter
          // to match features with unique FIPS codes to activate
          // the `counties-highlighted` layer.
          var filter = features.reduce(function (memo, feature) {
            memo.push(feature.properties.parcel_id);

            var checkParcelId = feature.properties.parcel_id;
            var checkIndex = selectedRecords.indexOf(checkParcelId);
            var checkIndexDetails = selectedRecordDetails.indexOf(checkParcelId);
            if (checkIndex > -1) {
              selectedRecords.splice(checkIndex, 1);
              selectedRecordDetails.splice(checkIndexDetails, 1);
            } else {
              selectedRecords.push(feature.properties.parcel_id);
              //Add records to selectedRecordDetails and get parcel details for each one using parcel details api
              feature.properties.selected = true;
              var parcelDetails = {};
              fetch.getItem(`api/data/parcels`, feature.properties.parcel_id)
                .then(response => {
                  parcelDetails = response.data[0];
                  parcelDetails.selected = true;
                  selectedRecordDetails.push(parcelDetails);
                })
                .catch(error => {
                  console.log(error);
                });

            }
            return memo;
          }, ['in', 'parcel_id']);
          $scope.selectedRecords = selectedRecords;
          if ($scope.type === 'zoning') {
            $('#parcelZNCount').html('Update Parcels (' + $scope.selectedRecords.length + ')');
          } else if ($scope.type === 'lu') {
            $('#parcelGPCount').html('Update Parcels (' + $scope.selectedRecords.length + ')');
          }

          var array1 = ['in', 'parcel_id'];
          var array2 = $scope.selectedRecords;

          var array3 = array1.concat(array2);


          map.setFilter("parcels-highlighted", array3);

          // $('#sidebar').addClass('show');


        }

        // map.target.dragPan.enable();

      }

      map.on('draw.create', function (e) {

        var userPolygon = e.features[0];

        // generate bounding box from polygon the user drew
        var polygonBoundingBox = turf.bbox(userPolygon);

        var southWest = [polygonBoundingBox[0], polygonBoundingBox[1]];
        var northEast = [polygonBoundingBox[2], polygonBoundingBox[3]];

        var northEastPointPixel = map.project(northEast);
        var southWestPointPixel = map.project(southWest);

        var features = map.queryRenderedFeatures([southWestPointPixel, northEastPointPixel], {
          layers: ['parcels']
        });


        var filter = selectedRecords.reduce(function (memo, feature) {

          if (!(undefined === turf.intersect(feature, userPolygon))) {
            // only add the property, if the feature intersects with the polygon drawn by the user

            memo.push(feature.properties.parcel_id);
            selectedRecords.push(feature.properties.parcel_id);
          }
          return memo;
        }, ['in', 'parcel_id']);

      
        var array1 = ['in', 'parcel_id'];
        var array2 = selectedRecords;

        var array3 = array1.concat(array2);


        map.setFilter("parcels-highlighted", array3);

      });


      map.on('style.load', function (map) {
        loadMapLayers(map);
      });

      // Add source and layer whenever base style is loaded
      $scope.map = map;
      $scope.stationAreaLayerToggle = true;
      // $scope.sphereofinfluenceLayerToggle = true;
    }

    $scope.updateMap = function () {
      $scope.saving = true;
      var filters = ["all"];
      console.log($scope.filter)
      fetch.updateItem(`api/data/parcels/map/filter`, $scope.filter)
        .then(response => {
        console.log(response)
         if(response.data.length > 0){
          var filteredParcels = [];
          response.data.forEach(element => {
            filteredParcels.push(element.parcel_id);
          });
          var array1 = ["in", "parcel_id"];
          var array2 = filteredParcels;

          var array3 = array1.concat(array2);
          $scope.map.setFilter('parcels', array3);
          // $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", filteredParcels]);
          // $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", response.data]);
          // $scope.map.setFilter('parcels', ["in", "parcel_id", response.data])
          //Clear features previously selected
          $scope.clearSelected();


          if ($scope.map.getFilter('sphereofinfluenceLayer')) {
            $scope.map.setFilter("sphereofinfluenceLayer", [
              "match", [
                "get",
                "jurisdiction"
              ],
              [
                $scope.filter.jurisdiction
              ],
              true,
              false
            ]);
          }

          if ($scope.map && $scope.filter.station_name) {
            $scope.zoomToStation($scope.filter.station_name);
          }

          $scope.saving = false;
         } else if(response.data.length == 0){
          $scope.map.setFilter('parcels', ["in", "parcel_id", ""]);
          $scope.saving = false;
         }
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })




    }



    $scope.zoomToStation = function (station_name) {
      //Zoom map to jurisdiction currently logged in
      var zoomToFeature = _.filter(stationAreasGeojson.features, function (item) {
        return item.properties.station_name === station_name;
      });

      var bbox = turf.extent(zoomToFeature[0].geometry);
      $scope.map.fitBounds(bbox, {
        padding: -150,
      });
      // $scope.map.scrollWheelZoom.enable();

    }



    /**
* Get list of zoning codes by jurisdiction
* @param {*} jurisdiction 
*/
    $scope.getZoningCodes = function (jurisdiction) {
      fetch.getAllItems(`api/data/density/zoning/${jurisdiction}`)
        .then(response => {
          
          $scope.znCodes = response.data;
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }


    $scope.clearSelected = function () {
      $scope.map.setFilter('parcel-selected', ["in", "parcel_id", ""])
      $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", ""])
      $scope.selectedRecords = [];
      $scope.selectedRecordDetails = [];
      $scope.parcels = {
        zn_recid: '',
        percentOfParcel: '',
        secondZnRecid: '',
        secondPercentOfParcel: '',
        exclude: '',
        excludeZnCode: ''
      };
    }

    $scope.clearParcelSelection = function () {
      $scope.selectedRecordDetails = []; 
      $scope.map.setFilter('parcels-highlighted', ["in", "parcel_id", ""]); 
    }

    $scope.updateCheckedParcels = function (item) {
      if (!$scope.parcelSelected) {
        $scope.selectedRecordDetails = _.remove($scope.selectedRecordDetails, function (e) {
          return e.parcel_id != item.parcel_id;
        });
        var checkIndex = $scope.selectedRecords.indexOf(item.parcel_id);
        $scope.selectedRecords.splice(checkIndex, 1);
        var array1 = ["in", "parcel_id"];
        var array2 = $scope.selectedRecords;
        var array3 = array1.concat(array2);

        // Set the filter to populate features into the layer.
        $scope.map.setFilter("parcels-highlighted", array3);
        $scope.map.selectedFilter = array3;
      }
     }

     $scope.updateParcels = function () {
      $scope.saving = true;
      $scope.pendingParcelUpdates = [];
      console.log($scope.parcels)

     

    
      // Check if Exclude by Zoning Code is selected
      if ($scope.parcels.excludeZnCode && $scope.parcels.excludeZnCode !== '') {
        $scope.pendingParcelUpdates.push({
          zn_recid: $scope.parcels.excludeZnCode,
          type: 'exclude_by_zoning_code'
        });
      } else {
       
        // Iterate through selected parcels to update with primary and secondary zoning codes
        $scope.selectedRecordDetails.forEach(element => {
          
          // Primary Zoning Code and Percentage
          if ($scope.parcels.zn_recid && $scope.parcels.zn_recid !== '') {
            console.log('check 1')
            var updateData = {
              parcel_id: element.parcel_id,
              zn_recid: $scope.parcels.zn_recid,
              type: 'primary_zoning'
            };
            if ($scope.parcels.percentOfParcel && $scope.parcels.percentOfParcel !== '') {
              updateData.percent_of_parcel = $scope.parcels.percentOfParcel;
            }
            if ($scope.parcels.exclude && $scope.parcels.exclude !== '') {
              updateData.exclude = $scope.parcels.exclude;
            }
            $scope.pendingParcelUpdates.push(updateData);
          }

         
          // Secondary Zoning Code and Percentage (if provided)
          if ($scope.parcels.secondZnRecid && $scope.parcels.secondZnRecid !== '') {
            console.log('check 2')
            var updateData = {
              parcel_id: element.parcel_id,
              zn_recid: $scope.parcels.secondZnRecid,
              type: 'secondary_zoning'
            };
            if ($scope.parcels.secondPercentOfParcel && $scope.parcels.secondPercentOfParcel !== '') {
              updateData.percent_of_parcel = $scope.parcels.secondPercentOfParcel;
            }
            if ($scope.parcels.exclude && $scope.parcels.exclude !== '') {
              updateData.exclude = $scope.parcels.exclude;
            }
            $scope.pendingParcelUpdates.push(updateData);
          }

          if($scope.parcels.exclude && $scope.parcels.exclude !== '' && (!$scope.parcels.zn_recid || $scope.parcels.zn_recid == undefined || $scope.parcels.zn_recid === '')){
            console.log('check 3')
            $scope.pendingParcelUpdates.push({
              parcel_id: element.parcel_id,
              exclude: $scope.parcels.exclude,
              type: 'primary_zoning'
            });
          }
          
          
          
        });
      }

      console.log($scope.pendingParcelUpdates);
    
      // Send updates to the server
      fetch.updateItem('api/data/parcels', $scope.pendingParcelUpdates)
        .then(response => {
          // Reset the form and UI state after success
          $scope.pendingParcelUpdates = [];
          $scope.saved = true;
          $scope.saving = false;
          $scope.parcels = {}; // Reset parcel data
    
          // Update the excluded parcels layer (if applicable)
          $scope.updateExcludedParcelsLayer();
    
          // Switch to the Parcel List tab
          var parcelListTab = angular.element('#parcel-list-tab'); // Get Parcel List tab by its ID
          var tabButton = angular.element('#parcel-list'); // Tab content for Parcel List
    
          // Set active class to the Parcel List tab and remove from the other tab
          angular.element('.nav-link').removeClass('active');
          parcelListTab.addClass('active');
          angular.element('.tab-pane').removeClass('show active');
          tabButton.addClass('show active');
    
          // Reset the UI to show success message for a short period
          setTimeout(() => {
            $scope.saved = false;
            $scope.clearSelected();
            $scope.$apply(); // Ensure Angular updates the DOM
          }, 3000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        });
    }
    
    

    $scope.updateExcludedParcelsLayer = function () {
      fetch.getAllItems(`api/data/excludedparcels/${$scope.currentJurisdiction}`)
        .then(response => {
          if(response.data.length > 0){
            $scope.excludedParcels = response.data;
          var array1 = ["in", "parcel_id"];
          var array2 = $scope.excludedParcels;
          var array3 = array1.concat(array2);
          // $scope.map.setFilter('parcels-excluded', ["in", "parcel_id", ""]);
          $scope.map.setFilter('parcels-excluded', array3);
          } else {
            $scope.map.setFilter('parcels-excluded', ["in", "parcel_id", ""]);
          }
        }
        )
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }

    $scope.manageLayers = function (layer) {
    }

    $scope.manageTabPanels = function (type) {
      $scope.tabPanelTypes.forEach(element => {
        if (element.tab === type) {
          $(`#${element.tab}`).addClass('show');
          element.active = true;
        } else {
          $(`#${element.tab}`).removeClass('show');
          element.active = false;
        }
      });
    }

    $scope.updateBaseMap = function (type) {
      // 1. Store the current layers
      $scope.currentLayers = $scope.map.getStyle().layers;

      // 2. Change the basemap style
      $scope.map.setStyle('mapbox://styles/mapbox/' + type);

      // 3. Re-add the layers after the style change
      //  $scope.currentLayers.forEach(layer => {
      //    if (layer.id === 'parcels' && layer.id === 'stationAreaLayer' && layer.id === 'jurisdiction-boundary' && layer.id === 'parcels-highlighted' && layer.id === 'parcel-selected') {
      //      $scope.map.addLayer(layer);
      //    }
      //  });

      // 4. Re-apply filters to the parcels layer
      $scope.loadMapLayers();
   // $scope.reAddLayers();
    }

    $scope.loadMapLayers = function () {
      //    Add Parcels Source
      if (!$scope.map.getSource("parcelsSource")) {
        $scope.map.addSource("parcelsSource", {
          type: "vector",
          url: "mapbox://mtc-basis.toc_parcels_v24d", //Parcel Atlas (updated September 20 2021) 
        })
      }

      //    Add Station Areas Source
      if (!$scope.map.getSource("stationAreaLayerSource")) {
        $scope.map.addSource("stationAreaLayerSource", {
          type: "geojson",
          data: stationAreasGeojson,
        });
      }


      //Add jurisdiction boundary source
      if (!$scope.map.getSource("jurisdictionBoundarySource")) {
        $scope.map.addSource("jurisdictionBoundarySource", {
          type: "geojson",
          data: placesGeoJSON,
        });
      }


      // Only add layer if it doesnt exist already 
      if ($scope.map.getLayer("parcels")) {
        $scope.map.removeLayer("parcels");
      }
  
      $scope.map.addLayer({
        id: "parcels",
        type: "fill",
        source: "parcelsSource",
        "source-layer": "toc_parcels_v24d",
        'paint': {
          "fill-outline-color": "black",
          'fill-color': "white",
          'fill-opacity': 0.5
        },

      });
   
      if (!$scope.map.getLayer("stationAreaLayer")) {
        $scope.map.addLayer({
          id: "stationAreaLayer",
          type: "fill",
          source: "stationAreaLayerSource",
          'paint': {
            "fill-outline-color": "white",
            'fill-color': {
              'property': 'service_tier',
              'type': 'categorical',
              'stops': [
                [1, 'yellow'],
                [2, 'orange'],
                [3, 'green'],
                [4, 'blue']
              ],
              'default': 'white',
            },
            'fill-opacity': 0.5
          },
          'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
          }

        }, 'parcels');
      }

      //Jurisdiction Layer

      if (!$scope.map.getLayer("jurisdiction-boundary")) {
        $scope.map.addLayer({
          id: "jurisdiction-boundary",
          type: "line",
          source: "jurisdictionBoundarySource",
          paint: {
            "line-color": "black",
            "line-width": 0.75,
          },
          filter: ["in", "NAME", ""],
        });
      }

      //Excluded Parcels
      if (!map.target.getLayer("parcels-excluded")) {
        map.target.addLayer({
          id: "parcels-excluded",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "toc_parcels_v24d",
          paint: {
            "fill-outline-color": "white",
            "fill-color": "darkgray",
            "fill-opacity": 0.75,
          },
          filter: ["in", "parcel_id", ""],
        }); // Place polygon under these labels.
      }

      fetch.getAllItems(`api/data/excludedparcels`, $scope.currentJurisdiction)
        .then(response => {
          
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }

        })


      //Selected Parcels
      if (!$scope.map.getLayer("parcels-highlighted")) {
        $scope.map.addLayer({
          id: "parcels-highlighted",
          type: "fill",
          source: "parcelsSource",
          "source-layer": "toc_parcels_v24d",
          paint: {
            "fill-outline-color": "darkgray",
            "fill-color": "#00fffa",
            "fill-opacity": 0.75,
          },
          filter: ["in", "parcel_id", ""],
        }); // Place polygon under these labels.
      }

      //Currently Selected Parcel
      if (!$scope.map.getLayer("parcel-selected")) {
        $scope.map.addLayer({
          id: "parcel-selected",
          type: "line",
          source: "parcelsSource",
          "source-layer": "toc_parcels_v24d",
          'paint': {
            'line-color': '#888',
            'line-width': 6
          },
          filter: ["in", "parcel_id", ""],
        }); // Place polygon under these labels.
      }

      // ADD MAP LAYERS 
      $scope.mapLayers.forEach(element => {
        if (element.name === 'countyLayer') {
          $scope.map.addSource(`${element.name}Source`, {
            type: 'geojson',
            // Use a URL for the value for the `data` property.
            data: element.url
          });

          $scope.map.addLayer(
            {
              id: element.name,
              type: "line",
              source: `${element.name}Source`,
              paint: element.paint,
              'layout': {
                // Make the layer visible by default.
                'visibility': 'none'
              }
            }
          );
        }

      }, "parcels");
      //Update any existing filters
      $scope.updateMap();

    }

    $scope.showParcelDetails = function (parcel) {
      $scope.showParcelDetailsPanel = true;
      $scope.parcel = parcel;
      fetch.getItem(`api/data/multizone/parcels`, parcel.parcel_id)
        .then(response => {
          console.log(response);
          $scope.parcelMultizoneDetails = response.data;
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }

    $scope.backToSelected = function () {
      $scope.showParcelDetailsPanel = false;
    }

  }

  $onInit() {
    this.userService.getCurrentUser()
      .then(response => {
       this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.getJurisdictionList();
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          this.$state.go('login');
        }
      })

    //Get list of toggle map layers [Map Service]
    this.$scope.mapLayers = this.mapService.getMapLayers();
  }

  /**
   * Get list of jurisdictions to populated dropdown
   */
  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }
        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.filter.jurisdiction = this.$scope.currentJurisdiction;
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
        this.$scope.getZoningCodes(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }


  resetFilters() {
    // Reset the filter object
    // this.$scope.filter = {};
    // loop through the keys in this.$scope.filter and delete key if allows_comm_office or allows_residential or zn_code
    for (var key in this.$scope.filter) {
      if (key === 'allows_comm_office' || key === 'allows_residential' || key === 'zn_code' || key === 'zn_recid') {
        delete this.$scope.filter[key];
      }
    }
   

    // if (this.$scope.map) {
    //   this.$scope.map.remove();
    //   this.$scope.map = null;
    // }
    // this.$scope.loadMap();
    // Reset the jurisdiction filter (optional)
    // this.$scope.filter.jurisdiction = this.$scope.currentJurisdiction;
    // // Set the station_name filter to the currentSelectedStationId
    // this.$scope.filter.station_name = this.$scope.currentSelectedStationId;

    // // Update the map filters based on the reset filter object
    this.$scope.updateMap();
    // // Zoom to the selected station area (optional)
    console.log(this.$scope.filter.station_name);
    this.$scope.zoomToStation(this.$scope.filter.station_name);
  }





  toggleMapLayer(layerName) {
    this.$scope.visibleLayer = layerName;
    var visibility;
    this.$scope.loadingDiv = true;
    var type;
  
    // Handle stationAreaLayer separately
    if (layerName === 'stationAreaLayer') {
      if (this.$scope.map.getSource('stationAreaLayerSource')) {
        visibility = this.$scope.map.getLayoutProperty(layerName, "visibility");
  
        // Toggle layer visibility
        if (visibility === "visible") {
          this.$scope.map.setLayoutProperty(layerName, "visibility", "none");
          this.$scope.visibleLayer = null;
          this.className = "";
        } else {
          this.className = "active";
          this.$scope.map.setLayoutProperty(layerName, "visibility", "visible");
        }
        this.$scope.loadingDiv = false;
      }
    }
  
    // Handle other layers, including jurisdiction-boundary
    for (let index = 0; index < this.$scope.mapLayers.length; index++) {
      const element = this.$scope.mapLayers[index];
      if (element.name === layerName) {
        if (this.$scope.map.getSource(element.source)) {
          visibility = this.$scope.map.getLayoutProperty(element.name, "visibility");
  
          // Toggle layer visibility
          if (visibility === "visible") {
            this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
            this.$scope.visibleLayer = element.name;
            this.className = "";
          } else {
            this.className = "active";
            this.$scope.map.setLayoutProperty(element.name, "visibility", "visible");
          }
          this.$scope.loadingDiv = false;
        } else {
          var $scope = this.$scope;
  
          // Load layer data if the source doesn't exist
          $.ajax({
            url: element.url,
            method: "GET",
            dataType: "json",
            success: function (data, status, jqxhr) {
              var layerData = data;
              var paint = {};
  
              // Configure paint based on layer type
              if (element.type === 'mapbox') {
                paint = {
                  "fill-outline-color": "white",
                  "fill-color": element.fillColor,
                  "fill-opacity": 0.4,
                };
  
                $scope.map.addSource(element.source, {
                  type: layerData.sources.composite.type,
                  url: layerData.sources.composite.url,
                });
              } else if (element.type === 'socrata') {
                if (element.style === 'numerical' || element.style === 'circle') {
                  layerData.features.forEach(data => {
                    data.properties[element.property] = parseFloat(data.properties[element.property]);
                  });
                }
                paint = element.paint;
                $scope.map.addSource(element.source, {
                  type: "geojson",
                  data: layerData,
                });
              }
  
              // Add the layer to the map
              if (element.type === 'mapbox') {
                if (layerData.layers[0].filter) {
                  $scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                    filter: layerData.layers[0].filter,
                  }, "parcels");
                } else {
                  $scope.map.addLayer({
                    id: element.name,
                    type: layerData.layers[0].type,
                    source: element.source,
                    "source-layer": layerData.layers[0]["source-layer"],
                    paint: layerData.layers[0].paint,
                  }, "parcels");
                }
              } else if (element.type === 'socrata') {
                type = element.style === 'circle' ? 'circle' : 'fill';
                $scope.map.addLayer({
                  id: element.name,
                  type: type,
                  source: element.source,
                  paint: element.paint,
                }, 'parcels');
              }
  
              // Set layer visibility to "visible"
              $scope.map.setLayoutProperty(element.name, "visibility", "visible");
  
              // Apply additional configurations
              if (element.name !== 'sphereofinfluenceLayer' && element.type === 'mapbox') {
                $scope.map.setPaintProperty(element.name, "fill-opacity", 0.5);
              }
  
              if (element.name === 'znLayer' || element.name === 'gpLayer') {
                $scope.map.setFilter(element.name, ["in", "jurisdiction", $scope.jurisdiction]);
              }
  
              if (element.name === 'sphereofinfluenceLayer') {
                $scope.map.setFilter(element.name, [
                  "match",
                  ["get", "jurisdiction"],
                  [$scope.jurisdiction],
                  true,
                  false
                ]);
              }
  
              $scope.loadingDiv = false;
            },
            error: function (jqxhr, status, error) {
              console.log("Something went wrong!");
              console.log(status, error);
              $scope.loadingDiv = false;
            }
          });
        }
      } else {
        if (this.$scope.map.getSource(element.source)) {
          this.$scope.map.setLayoutProperty(element.name, "visibility", "none");
          this.$scope[element.name + "Toggle"] = false;
          this.$scope.loadingDiv = false;
        }
      }
      this.$scope.loadingDiv = true;
    }
  }
}

export default angular.module('appApp.map', [uiRouter])
  .config(routes)
  .component('map', {
    template: require('./map.html'),
    controller: MapComponent,
    controllerAs: 'mapCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/map/map.component.js